export default class Onboarding {
	constructor() {
		this.requestPasswordReset = document.getElementById('onboarding-request-password-reset');
		this.resetPassword = document.getElementById('onboarding-forgot-password');
		this.signUp = document.getElementById('onboarding-signup');
		this.login = document.getElementById('onboarding-login');

		if(this.resetPassword) {
			this.resetPassword &&
			this.resetPassword.addEventListener("submit", (event) => {
				event.preventDefault();
				this.veritonePasswordReset();
			});
		}
	}

	// Veritone Login
	veritoneLogin() {
		document.body.classList.remove("loaded");
		let formData 	= new FormData(document.getElementById("onboarding-login"));
		let onboardingErrors	= document.getElementById("login-errors");

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneLogin', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			if(data['status'] === 200) {
				// Success
				document.cookie="token="+data['tokenInfo']['token']+"; expires="+data['tokenInfo']['expireInSeconds']+"; path=/";
				onboardingErrors.innerHTML = '';
				onboardingErrors.classList.remove('form-group__errors--open');
				// location.reload();
				document.body.classList.remove("modal--open");
				setTimeout(() => {
					document.querySelector('#modal__shell .modal__content').innerHTML = '';
					document.querySelector('#modal__shell').className = '';
					document.querySelector('#modal__shell').classList.add('modal');

					location.reload();

				}, 250);

				if(window.app.smoother) {
					window.app.smoother.paused(false);
				}
			} else if(data['status'] === 401) {
				// Invalid
				onboardingErrors.innerHTML = 'The email or password is incorrect';
				onboardingErrors.classList.add('form-group__errors--open');
			} else {
				// Generic catch all
				onboardingErrors.innerHTML = 'There has been an unexpected error, please refresh and try again';
				onboardingErrors.classList.add('form-group__errors--open');
			}
			document.body.classList.add("loaded");
		})
	}

	veritoneRequestPasswordReset() {
		document.body.classList.remove("loaded");
		let formData 				= new FormData(document.getElementById("onboarding-request-password-reset"));
		let onboardingErrors				= document.getElementById("password-request-errors");

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneRequestPasswordReset', {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then(data => {
				onboardingErrors.innerHTML = 'Password reset request successful. Please check your email inbox.';
				onboardingErrors.classList.add('form-group__errors--open');
				document.body.classList.add("loaded");
			})
	}

	veritonePasswordReset() {
		document.body.classList.remove("loaded");
		let formData	= new FormData(document.getElementById("onboarding-forgot-password"));
		let onboardingErrors	= document.getElementById("password-reset-errors");

		fetch('/wp/wp-admin/admin-ajax.php?action=veritonePasswordReset', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			onboardingErrors.innerHTML = 'Password reset successful.';
			onboardingErrors.classList.add('form-group__errors--open');
			document.body.classList.add("loaded");
		})
	}

	veritoneSignUp() {
		document.body.classList.remove("loaded");
		let formData 				= new FormData(document.getElementById("onboarding-signup"));
		let onboardingSignUp			   	= document.getElementById("modal__onboarding-signup");
		let onboardingErrors				= document.getElementById("signup-errors");

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneSignUp', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			if(data['fieldErrors']) {
				data['fieldErrors'].forEach((error) => {
					let fieldName = error['field'];

					if(fieldName === 'emailAddress') {
						fieldName = 'Email address';
					}

					onboardingErrors.innerHTML = '';
					onboardingErrors.innerHTML += fieldName +' '+ error['message'];
				});
				onboardingErrors.classList.add('form-group__errors--open');
			} else {
				this.modalContent 		= document.querySelector('#modal__shell .modal__content');
				let formData	= new FormData();
				// Change this to successful order modal once it's built
				formData.append('modalName', 'sign-up--success');

				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					this.modalContent.innerHTML = '';
					this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
					document.body.classList.add('modal--open');
					document.body.classList.add("loaded");
				})
			}
			document.body.classList.add("loaded");
		})
	}
}